import React from 'react';
import { User } from 'lucide-react';
import { EMPTY_VALUE_TEXT } from '../constants/profileConfig';
import { getVisibleFields } from '../constants/profileFields';
import { FIELD_ICONS } from './profileIcons';
import ProfileSectionCard from './ProfileSectionCard';

/** One read-only detail: an icon, the label, and the value. */
const DetailRow = ({ field, profile }) => {
    const Icon = FIELD_ICONS[field.icon];
    const raw = profile[field.key];
    const hasValue = raw !== undefined && raw !== null && raw !== '';

    let content = EMPTY_VALUE_TEXT;
    if (hasValue) {
        content = field.badge
            ? <span className={`prof-badge prof-status-${profile.statusKey || 'unknown'}`}>{raw}</span>
            : raw;
    }

    return (
        <div className="prof-row">
            <span className="prof-row-icon" aria-hidden="true"><Icon size={16} /></span>
            <div className="prof-row-text">
                <dt className="prof-row-label">{field.label}</dt>
                <dd className={`prof-row-value${hasValue ? '' : ' empty'}${hasValue && field.personal ? ' dont-translate' : ''}`}>
                    {content}
                </dd>
            </div>
        </div>
    );
};

/**
 * Every detail of the profile except the internal ones (the user's id, manager id and whether a
 * password is set), in one card. Admins and team leads do not see a reporting manager.
 */
const ProfileDetails = ({ profile }) => (
    <div className="prof-cards">
        <ProfileSectionCard title="Profile information" subtitle="Your personal and work details" icon={User} index={0}>
            <dl className="prof-rows prof-rows-grid">
                {getVisibleFields(profile).map((field) => <DetailRow key={field.key} field={field} profile={profile} />)}
            </dl>
        </ProfileSectionCard>
    </div>
);

export default ProfileDetails;
